// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/theme/catboxes/module';
import './modules/evox/login/module';
import './modules/evox/merchandising/module';
import './modules/theme/catalogues/module';
import './modules/evox/shop-all/module';

// layouts

// leave me last
import './js/splide-init';
import './js/base/base-end';
